import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from "react";

interface LeadDrawerContextValue {
  leadId: string | null;
  openLead: (id: string) => void;
  closeLead: () => void;
}

const LeadDrawerContext = createContext<LeadDrawerContextValue | null>(null);

export function LeadDrawerProvider({ children }: { children: ReactNode }) {
  const [leadId, setLeadId] = useState<string | null>(null);

  const openLead = useCallback((id: string) => setLeadId(id), []);
  const closeLead = useCallback(() => setLeadId(null), []);

  const value = useMemo(() => ({ leadId, openLead, closeLead }), [leadId, openLead, closeLead]);

  return <LeadDrawerContext.Provider value={value}>{children}</LeadDrawerContext.Provider>;
}

export function useLeadDrawer(): LeadDrawerContextValue {
  const ctx = useContext(LeadDrawerContext);
  if (!ctx) throw new Error("useLeadDrawer precisa estar dentro de <LeadDrawerProvider>.");
  return ctx;
}
